import authAxios from '../common/authAxios';
import { NotificationDtoRequest } from '../interfaces/Notification/request/NotificationDtoRequest';
import { MessageDtoResponse } from '../interfaces/Notification/response/MessageDtoResponse';
import { NotificationDtoRsponse } from '../interfaces/Notification/response/NotificationDtoResponse';

export class NotificationService {
    static createNotification(data: NotificationDtoRequest) {
        return authAxios.post<any>('/astanait-authorization-module/api/v1/notification', data);
    }

    static getNotification() {
        return authAxios.get<NotificationDtoRsponse[]>(
            `/astanait-authorization-module/api/v1/notification/principal/new`, {
            headers: {
                showNotification: false
            }
        }
        );
    }

    static getNotificationByUser(page: number) {
        return authAxios.get<{ data: NotificationDtoRsponse[]; total_pages: number }>(
            `/astanait-authorization-module/api/v1/notification/principal?page=${page}&pageSize=10`
        );
    }

    static updateNotificationStatus(notificationId: number) {
        return authAxios.put(`/astanait-authorization-module/api/v1/notification?id=${notificationId}`);
    }

    static getAllNotification(page: number) {
        return authAxios.get<{ data: NotificationDtoRsponse[]; total_pages: number }>(
            `/astanait-authorization-module/api/v1/notification?page=${page}&pageSize=10`
        );
    }

    static getMessage(params: any, page: number, pageSize: number) {
        for (const key of Object.keys(params)) {
            if (!params[key]) {
                delete params[key];
            }
        }

        return authAxios.get<{ data: MessageDtoResponse[]; total_pages: number }>(
            `/astanait-authorization-module/api/v1/notification/message?page=${page}&pageSize=${pageSize}`,
            { params }
        );
    }

    static getStudentsByMessageId(messageId: number, studentsPage: number) {
        return authAxios.get<{ data: NotificationDtoRsponse[]; total_pages: number }>(
            `/astanait-authorization-module/api/v1/notification/message/${messageId}?page=${studentsPage}&pageSize=10`
        );
    }

    static getNumberOfStudents(messageId: number) {
        return authAxios.get<any>(
            `/astanait-authorization-module/api/v1/notification/message/${messageId}/number-of-students`
        );
    }
}